import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.n5u_1 = call;
        this.o5u_1 = data.h5l_1;
        this.p5u_1 = data.g5l_1;
        this.q5u_1 = data.j5l_1;
        this.r5u_1 = data.i5l_1;
        this.s5u_1 = data.l5l_1;
      }
      u5i() {
        return this.n5u_1;
      }
      bw() {
        return this.u5i().bw();
      }
      v5i() {
        return this.o5u_1;
      }
      w5i() {
        return this.p5u_1;
      }
      z2n() {
        return this.q5u_1;
      }
      u51() {
        return this.r5u_1;
      }
      o5i() {
        return this.s5u_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
